import { SessionGetter, SessionSetter } from "../../components/portal/state";
import { getSession, setSession } from "../../components/portal/login";
import { ExtraUserInfo } from "../portal_client";

export let get_session:SessionGetter<ExtraUserInfo> = getSession //replace with your custom session getter
export let set_session:SessionSetter<ExtraUserInfo> = setSession //replace with your custom session setter 